import { JurisdictionsEnum } from '@libs/backend-common';
export const BrandName = {
    [JurisdictionsEnum.GE]: 'Bitnet',
    [JurisdictionsEnum.UA]: 'Crexone',
    [JurisdictionsEnum.EU]: 'Bitnet',
};
//# sourceMappingURL=brandName.js.map